/* @flow */
/**
 * index.js
 * Written by: Alex Kasemir
 */

import authedUser from './authedUser';
import selectedUser from './selectedUser';
import selectedUserStats from './selectedUserStats';
import selectedUserStatsByQuizCompleted from './selectedUserStatsByQuizCompleted';
import selectedUserQuestions from './selectedUserQuestions';
import selectedUserBadges from './selectedUserBadges';
import selectedUserError from './selectedUserError';
import referralUser from './referralUser';
import selectedAuthUserPreferences from './selectedAuthUserPreferences/selectedAuthUserPreferences';
import selectedUserBestWorst from './selectedUserBestWorst';

export default {
  authedUser,
  selectedUser,
  selectedUserStats,
  selectedUserStatsByQuizCompleted,
  selectedUserQuestions,
  selectedUserBadges,
  selectedUserError,
  referralUser,
  selectedAuthUserPreferences,
  selectedUserBestWorst,
};
